'use client';

import {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  forwardRef,
  useEffect,
  useState,
} from 'react';
import style from './play-button.module.scss';
import { clsx } from 'clsx';
import { IconPause, IconPlay } from '../icons';
import { useAppSelector } from '../../../store/hooks';
import {
  getPlayer,
  setActiveTrackNum,
  setPause,
  setPlay,
  setTrackList,
} from '../../../store/slices/player.slices';
import { useDispatch } from 'react-redux';
import { IItem } from '../../../libs/types/page-home.types';
import { checkResponse } from '../../../libs/utils/check-response';
import * as process from 'process';

interface IProps
  extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  text: string;
  track?: IItem;
  playlistData?: string;
  radioBtn?: boolean;
}

export const PlayButton = forwardRef<HTMLButtonElement, IProps>(
  function PlayButton(props) {
    const {
      text,
      track = null,
      playlistData = null,
      className,
      radioBtn = false,
      ...otherProps
    } = props;
    const [isPlayTrack, setIsPlayTrack] = useState(false);
    const [textButton, setTextButton] = useState(text);

    /* Получаю треклист и флаг для проигрывания */
    const { isPlay, trakList } = useAppSelector(getPlayer);

    const dispatch = useDispatch();

    /* Включает либо один трек либо целый плейлист
     * в зависимости от того на какой ты странице */
    useEffect(() => {
      if (playlistData) {
        fetch(`${process.env.NEXT_PUBLIC_API_DOMAIN}${playlistData}`, {
          cache: 'no-store',
        })
          .then((res) => checkResponse(res))
          .then((res: IItem) => {
            if (isPlayTrack) {
              dispatch(setTrackList(res.items));
            }
          });
      }
    }, [isPlayTrack]);

    /* Управление кнопкой включения на картинке */
    useEffect(() => {
      if (!isPlay) {
        setIsPlayTrack(false);
      }
      if (text && isPlayTrack) {
        setTextButton('Остановить');
      } else {
        setTextButton(text);
      }
    }, [isPlay]);

    /* Включает или выключает проигрывание
     * а так же устанвливает плейлист */
    const onPlay = () => {
      if (!isPlay) {
        dispatch(setPlay());
        if (radioBtn) {
          ym(52577989, 'reachGoal', 'radiozvezda_play');
        }
      } else {
        dispatch(setPause());
        if (radioBtn) {
          ym(52577989, 'reachGoal', 'radiozvezda_pause');
        }
      }
      /* инициализирует новый треклист если
       * ранее не было включена эта программа
       * или адуиокнига и его позицию в плейлисте */
      if (!isPlayTrack && !playlistData) {
        dispatch(setTrackList([track]));
        dispatch(setPlay());
      }

      if (!isPlayTrack && playlistData) {
        dispatch(setTrackList(trakList));
        dispatch(setActiveTrackNum(0));
        dispatch(setPlay());
      }
      setIsPlayTrack(!isPlayTrack);
    };

    return (
      <button className={clsx(style.button, className)} {...otherProps} onClick={onPlay}>
        {isPlayTrack ? (
          <IconPause header={12} width={12} viewBox={'6 6 24 24'} />
        ) : (
          <IconPlay header={12} width={12} viewBox={'4 5 24 24'} />
        )}
        <span>{textButton}</span>
      </button>
    );
  },
);
